import { render, staticRenderFns } from "./StakingLogsFilters.vue?vue&type=template&id=644473d6&"
import script from "./StakingLogsFilters.vue?vue&type=script&lang=js&"
export * from "./StakingLogsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports